import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const RouteWatcher = () => {
    const location = useLocation();

    useEffect(() => {
        const watcherUrl = process.env.REACT_APP_WATCHER_URL;

        if (!watcherUrl) {
            console.warn('REACT_APP_WATCHER_URL is not defined in .env');
            return;
        }

        const sendWatchRequest = async () => {
            try {
                const response = await axios.post(watcherUrl, {
                    url: window.location.href,
                    path: location.pathname,
                    timestamp: new Date().toISOString()
                });

                console.log('Watcher response:', response.data);
            } catch (error) {
                console.error('Error sending watch request:', error);
            }
        };

        sendWatchRequest();
    }, [location]);

    return null;
};

export default RouteWatcher;
